import Api from '../api';

const SpeedrunLeaderboardSpotsAPI = {
  async getAll(params) {
    return Api.get(`/speedrun-leaderboard-spots?`, { params });
  },
  async getAllWithHistory(params) {
    return Api.get(`/speedrun-leaderboard-spots/show-change?`, { params });
  },
  async getAllWithHistoryDetailed(params) {
    return Api.get(`/speedrun-leaderboard-spots/show-change-detailed?`, {
      params
    });
  }
};

export default SpeedrunLeaderboardSpotsAPI;
